<template>

    <a rel="nofollow" :href="route('new_property.card', [propertyId ,propertySlug])" target="_blank"
        id="btnContact"
        class="btn btn-primary col-12 no-padding text-18 bold"
    >

        Contactar
    </a>
</template>
<script>
import {formatterErrorsLaravel} from "@/pages/publicpages/realestate/modal-save-search";
import GroupedErros from "@/vue/components/GroupedErrors";
import Loader from "@/vue/components/Loader";
import Recaptcha from "@/vue/components/Recaptcha";

export default {
    name: 'FormContact',
    props: {
        endpoint: {
            type: String,
            required: true,
        },
        modalIdentifier: {
            type: [String, null],
            required: false,
            default: null,
        },
        propertyId: {
            type: [Number, null],
            required: false,
            default: null,
        },
        propertySlug: {
            type: [String, null],
            required: false,
            default: null,
        },
    },
    data() {
        return {
            form: {
                hourDay: null,
                visitDay: null,
                requestVisit:null,
                test:null,
                senderName: null,
                senderEmail: null,
                senderPhone: null,
                consent: false,
                'g-recaptcha-response': null,
                page_url: null,
                       captcha: null,
            },
            errors: [],
            loading: false
        }
    },
    computed: {

        fullUrl() {
            return window.location.href
        },

    },
    mounted() {


        this.form.page_url = this.fullUrl
    },
    methods: {

    },
}
</script>
